import { render, staticRenderFns } from "./Regioes.vue?vue&type=template&id=0c880fc4&scoped=true&"
import script from "./Regioes.vue?vue&type=script&lang=js&"
export * from "./Regioes.vue?vue&type=script&lang=js&"
import style0 from "./Regioes.vue?vue&type=style&index=0&id=0c880fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c880fc4",
  null
  
)

export default component.exports